module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    directives: [{
      name: "drag-modal",
      rawName: "v-drag-modal"
    }],
    attrs: {
      "title": "约试听课",
      "width": "600",
      "mask-closable": false
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "trialLessonForm",
    staticClass: "form",
    attrs: {
      "model": _vm.trialLessonParam,
      "rules": _vm.ruleTrialLesson,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生信息"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.trialLessonParam.uid) + " - " + _vm._s(_vm.trialLessonParam.mobile) + " - " + _vm._s(_vm.trialLessonParam.nickname))])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始Level",
      "prop": "levelId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择等级，支持搜索",
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeLevel
    },
    model: {
      value: (_vm.trialLessonParam.levelId),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "levelId", _vm._n($$v))
      },
      expression: "trialLessonParam.levelId"
    }
  }, _vm._l((_vm.bookMaterialLevelList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title) + "(版本" + _vm._s(item.materialVersion) + ")\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教室",
      "prop": "schoolId"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.trialLessonParam.schoolId),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "schoolId", _vm._n($$v))
      },
      expression: "trialLessonParam.schoolId"
    }
  }, _vm._l((_vm.$constant.schoolEnums), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始课程",
      "prop": "lessonId"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.trialLessonParam.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "lessonId", _vm._n($$v))
      },
      expression: "trialLessonParam.lessonId"
    }
  }, _vm._l((_vm.bookMaterialLessonsList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title) + "\n              ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始时间",
      "prop": "lsnBeginDayTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 6
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Form-item', [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "clearable": false
    },
    on: {
      "on-change": _vm.lsnBeginTimeDateChange
    },
    model: {
      value: (_vm.trialLessonParam.lsnBeginTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "lsnBeginTimeDate", $$v)
      },
      expression: "trialLessonParam.lsnBeginTimeDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', [_c('Time-picker', {
    key: _vm.timePickerKey,
    attrs: {
      "clearable": false,
      "format": "HH:mm",
      "steps": [1, 30],
      "placeholder": "时间"
    },
    on: {
      "on-change": _vm.onChangeTime
    },
    model: {
      value: (_vm.timeStr),
      callback: function($$v) {
        _vm.timeStr = $$v
      },
      expression: "timeStr"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.trialLessonParam.timeLength),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "timeLength", _vm._n($$v))
      },
      expression: "trialLessonParam.timeLength"
    }
  }, _vm._l((_vm.timeLengthList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                    ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5",
      "offset": "1"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "loading": _vm.loadingSearch
    },
    on: {
      "click": _vm.searchTch
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "空课老师"
    }
  }, [_c('TeacherSelect', {
    attrs: {
      "category": [1, 2, 3],
      "isAudition": _vm.y,
      "label": _vm.tchName
    },
    on: {
      "on-change": _vm.onTchChange
    },
    model: {
      value: (_vm.tId),
      callback: function($$v) {
        _vm.tId = $$v
      },
      expression: "tId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "适宜级别"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.trialLessonParam.suitableLevel),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "suitableLevel", $$v)
      },
      expression: "trialLessonParam.suitableLevel"
    }
  }, [_c('Radio', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("全部")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("Level1")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "5"
    }
  }, [_c('span', [_vm._v("Level2")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("Level3-Level5")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("Level6-Level9")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "4"
    }
  }, [_c('span', [_vm._v("Wonders及其他")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "6"
    }
  }, [_c('span', [_vm._v("PU")])])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "tchId"
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.trialLessonParam.category),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "category", $$v)
      },
      expression: "trialLessonParam.category"
    }
  }, [_c('Radio', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("全部")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("全职老师")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("兼职老师")])])], 1), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.trialLessonParam.channel),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "channel", $$v)
      },
      expression: "trialLessonParam.channel"
    }
  }, [_c('Radio', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("全部")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("欧美")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("菲教")])])], 1), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.trialLessonParam.accent),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "accent", $$v)
      },
      expression: "trialLessonParam.accent"
    }
  }, [_c('Radio', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("全部")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("英音")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("美音")])])], 1), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.trialLessonParam.sex),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "sex", $$v)
      },
      expression: "trialLessonParam.sex"
    }
  }, [_c('Radio', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("全部")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("男")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("女")])])], 1)], 1), _vm._v(" "), _c('Row', [_c('Radio-group', {
    model: {
      value: (_vm.trialLessonParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.trialLessonParam, "tchId", _vm._n($$v))
      },
      expression: "trialLessonParam.tchId"
    }
  }, [_c('Row', _vm._l((_vm.tchList), function(item) {
    return _c('Col', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "span": 10
      }
    }, [_c('Radio', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.id) + " - " + _vm._s(item.firstName) + " " + _vm._s(item.lastName) + "\n                    ")]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.showTchMessage(item.id)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "120px",
        "height": "120px"
      },
      attrs: {
        "src": _vm.tchAvatarSrc(item.avatar)
      }
    })])], 1)
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingConfirm
    },
    on: {
      "click": _vm.insertTrialLesson
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('tch-info-modal', {
    staticClass: "tch-info-modal",
    attrs: {
      "canEdit": false,
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.updateTchInfoSuccess
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14eb2a4a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserTrialLessonModal.vue
// module id = 1635
// module chunks = 8